import axios from "./http-incep";
import unincepaxios from "./http-unintercept";
import aiAxios from "./ai-http-interceptor";
export default class HttpUtil {
  static post(url, params = {}) {
    return axios.post(url, params, {});
  }
  static put(url, params = {}) {
    return axios.put(url, params, {});
  }
  static get(url, params = {}) {
    return axios.get(url, params);
  }
  static delete(url, params = {}) {
    return axios.delete(url, params);
  }
  static patch(url, params = {}) {
    return axios.patch(url, params);
  }

  static postWithFileOCR(url, params = {}) {
    return aiAxios.post(url, params, {});
  }

  static getOCRProgress(url, params = {}) {
    return aiAxios.get(url, params, {});
  }

   //For APIs without Authorization header
   static uniterceptedPost(url, params = {}) {
    return unincepaxios.post(url, params, {});
  }
  static uniterceptedGet(url, params = {}) {
    return unincepaxios.get(url, params);
  }
  //For APIs without Authorization header end
}
